import { CalendarEvent } from 'mini-calendar-event-types';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { selectStringForCount } from 'mini-common-utils/lib/utils/selectStringForCount';

/**
 * default conflict string generator
 * @param item
 */
export const defaultGetConflictsText = ({ ActualConflictingMeetingCount }: CalendarEvent) => {
    const strings = getOwaMiniCommonStrings();

    return selectStringForCount(
        ActualConflictingMeetingCount,
        strings.singleConflictLabel,
        strings.dualConflictsLabel,
        strings.multipleConflictsLabel,
        strings.noConflictsLabel
    );
};
